import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import SignatureCanvas from 'react-signature-canvas';
import PDF from './PDF';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import file from '../../images/sample.pdf';
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index';
import { withRouter } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import withSizes from 'react-sizes';
import PropTypes from 'prop-types';
import { Tabs } from "@yazanaabed/react-tabs";
import UploadDocsSingleFile from '../Onboarding/UploadDocsSingleFile'
import axios from 'axios';

const styles = theme => ({
    body:{
        backgroundColor: 'grey',
    },
    sigPad:{
        backgroundColor: 'white',
        width: '100%',
        height: '100%',
    },
    container: {
        // margin: theme.spacing.unit * 5,
        // width: '100%',
        // minwidth: '30%',
        width: 389,
        // width: 730,
        minWidth: 100,
        height: 300,
        minHeight: 200,
        marginBottom:'15px',
        //top: '10%',
        // left: '10%',
        //overflowX: 'auto',
        //display: 'column',
        alignItem: 'center',
        margin: '0 Auto',
    },
    containerChi: {
        // margin: theme.spacing.unit * 5,
        // width: '100%',
        // minwidth: '30%',
        width: 530,
        // width: 730,
        minWidth: 100,
        height: 300,
        minHeight: 200,
        marginBottom:'15px',
        //top: '10%',
        // left: '10%',
        //overflowX: 'auto',
        //display: 'column',
        alignItem: 'center',
        margin: '0 Auto',
    },
    sigContainer: {
        // maxWidth: '100%',
        minwidth: '30%',
        height: '80%',
        alignItems:'center',
        backgroundColor: '#fff',
    },
    button: {
        padding:'3px',
        paddingRight:'5px',
        paddingLeft:'5px',
        marginRight:'5px',
        margin:'1px'
    },
    buttonChi: {
        padding:'5px',
        margin:'10px'
    },
    sizeSmall:{
        fontSize: '10px',
    },
    sigImage: {
        backgroundSize: '200px 50px',
        width: '200px',
        height: '200px',
        backgroundColor: 'white',
    },
    pdfMargin:{
        // paddingRight: 10
    },
});

class SignatureCanvasWrapperArbitrator extends Component{

    state = {
        trimmedDataURL: null,
        uniqueId: localStorage.getItem('token'),
        fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`,
        fileURLAward : `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_award`,
        fileDocURLAward :`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_award`,
        signSubmitted:true,
        file:this.props.file,
        signLoading: false,
        signLoadingNoSave: false,
        signLoadingAsDefault: false,
        hasDefaultSignature: false
    }

    sigPad={};

    clear = (name) => {
        this.sigPad[name].clear()
    }

    reload = () =>{
        window.location.reload()
    }

    deliveraward = () => {
        this.props.deliverAward(
            this.props.caseId
        );
    }

    useDefault = (name) => {
        this.setState({
            signLoadingAsDefault: true
        })
        
        this.props.uploadSignature(
            this.props.caseId,
            `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature.png`,
            localStorage.getItem('typeOfAccount'),
            name,
            '',
            true
        );
    
        this.setState({
            fileURL:"",
            signSubmitted:false
        })  

        setTimeout(()=>{

            this.forceUpdate();
            console.log('FORCING UPDATE@1')
            console.log('FORCING UPDATE localStorage.getItem(typeOfAccount):'+localStorage.getItem('typeOfAccount'))
            let userType = '';
            this.setState({ state: this.state });
            if(this.props.claimantUniqueId == this.state.uniqueId){
                userType = 'claimant';
                this.setState({
                    fileURL:`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`
                })  
            }else if(this.props.respondentUniqueId == this.state.uniqueId){
                userType = 'respondent';
                this.setState({
                    fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`
                })
            }
            else if (localStorage.getItem('typeOfAccount') == 'arbitrator' || localStorage.getItem('typeOfAccount') == 'admin'){
                this.setState({ file: '' })
            }
            
            if(this.props.claimantUniqueId == this.state.uniqueId){
                userType = 'claimant';
            }else if(this.props.respondentUniqueId == this.state.uniqueId){
                userType = 'respondent';
            }
            
        },3000)

        if (localStorage.getItem('typeOfAccount') == 'arbitrator' || localStorage.getItem('typeOfAccount') == 'admin'){
            this.updateFileURL(true, false);
        }
    }

    trim = (name, setDefault) => {

        if (setDefault == true){
            this.setState({
                signLoading: true
            })
        }
        else if (setDefault == false){
            this.setState({
                signLoadingNoSave: true
            })
        }
        console.log('Trimming setDefault: '+setDefault)
        console.log('Trimming name: '+name)
        console.log('Trimming name: '+JSON.stringify(name))
        let base_data = this.sigPad[name].getTrimmedCanvas().toDataURL('image/png');
        this.setState({trimmedDataURL : base_data.split(',')[1]});

        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        if (this.props.caseData.agreement_type == 'EstateAgentDispute' && userType == 'respondent'){
            if (localStorage.getItem('typeOfAccount') == 'user'){
                this.props.uploadSignature(
                    this.props.caseId
                    `${this.props.conversationId}_${userType}_signature_${name.toLowerCase()}.png`,
                    userType,
                    name,
                    base_data
                );
            }
            else{
                this.props.uploadSignature(
                    this.props.caseId,
                    `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature_${name.toLowerCase()}.png`,
                    localStorage.getItem('typeOfAccount'),
                    name,
                    base_data
                );
            }
        }
        else{
            if (localStorage.getItem('typeOfAccount') == 'user'){
                this.props.uploadSignature(
                    this.props.caseId,
                    `${this.props.conversationId}_${userType}_signature.png`,
                    userType,
                    name,
                    base_data
                );
            }
            else{
                console.log('FM setDefault testing')
                this.props.uploadSignature(
                    this.props.caseId,
                    `${this.props.conversationId}_${localStorage.getItem('typeOfAccount')}_signature.png`,
                    localStorage.getItem('typeOfAccount'),
                    name,
                    base_data,
                    false,
                    setDefault
                );
            }
        }

        this.setState({
            fileURL:"",
            signSubmitted:false
        })  

        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
            this.setState({
                fileURL:''
            })  
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
            this.setState({
                fileURL: ''
            })
        }
        else if (localStorage.getItem('typeOfAccount') == 'arbitrator' || localStorage.getItem('typeOfAccount') == 'admin'){
            this.setState({ file: '' })
            this.setState({
                fileDocURLAward: '',
                fileURLAward:''
            })
        }

        setTimeout(()=>{

            try{
                this.sigPad.clear()
            } catch(err){}
            console.log('FORCING UPDATE!@3')
            console.log('FORCING UPDATE localStorage.getItem(typeOfAccount):'+localStorage.getItem('typeOfAccount'))
            let userType = '';
            this.setState({ state: this.state });
            
            if(this.props.claimantUniqueId == this.state.uniqueId){
                userType = 'claimant';
            }else if(this.props.respondentUniqueId == this.state.uniqueId){
                userType = 'respondent';
            }

            if (localStorage.getItem('typeOfAccount') == 'arbitrator' || localStorage.getItem('typeOfAccount') == 'admin'){
                this.updateFileURL(false, true);
            }
            window.location.reload();
        },60000)

        
    }
   
    componentWillMount(){
        this.updateFileURL();

        let url = `${process.env.REACT_APP_SERVER_HOSTNAME}:${process.env.REACT_APP_SERVER_PORT}/getArbitratorDefaultSignature`;
        let payload = {
            arbitratorId: this.props.caseData.claimantArbitratorFixed
        }
        axios.post(url, payload)
        .then((response) => {
            console.log('getArbitratorDefaultSignature');
            console.log(response);
            if(response.data === 'error' || response.data === 'failed'){
                // do nothing
            }
            else{
                this.setState({
                    hasDefaultSignature: true
                })
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    updateFileURL(usingDefault = false, usingTrim = false){
        this.setState({
            fileURL:""
        })  

        setTimeout(()=>{
            console.log('FORCING UPDATE@@@')
            try{
            this.sigPad.clear()
            } catch(err){}
            let userType = '';

            if(this.props.claimantUniqueId == this.state.uniqueId){
                userType = 'claimant';
                this.setState({
                    fileURL:`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}`
                })  
            }else if(this.props.respondentUniqueId == this.state.uniqueId){
                userType = 'respondent';
                this.setState({
                    fileURL: `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_response`
                })
            }

            if (localStorage.getItem('typeOfAccount') == 'arbitrator' || localStorage.getItem('typeOfAccount') == 'admin'){
                this.setState({
                    fileURLAward : `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_award`,
                    fileDocURLAward :`${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_award`,
                })
            }

            if (usingDefault){
                this.setState({
                    signLoadingAsDefault: false
                })
            }

            if (usingTrim){
                this.setState({
                    signLoading: false,
                    signLoadingNoSave: false
                })
            }

        },30000)
    }
    
    render(){
        const { classes } = this.props;
        let { trimmedDataURL } = this.state;
        const lang = localStorage.getItem('language');
        console.log('langCan: '+lang)
        
        let userType = '';
        if(this.props.claimantUniqueId == this.state.uniqueId){
            userType = 'claimant';
        }else if(this.props.respondentUniqueId == this.state.uniqueId){
            userType = 'respondent';
        }

        if (userType == 'respondent'){
            console.log('signatureCanvasWrapper userType: respondent')
            if (this.props.caseData.agreement_type == 'EstateAgentDispute'){
                console.log('signatureCanvasWrapper agreement_type: EstateAgentDispute')

                if (this.props.caseData.a1 == 'sole'){
                    console.log('signatureCanvasWrapper a1: sole')

                    if (this.props.caseData.a2 == 'vendor'){
                        console.log('signatureCanvasWrapper a2: vendor')
                        if (this.props.caseData.namesOfVendors !== undefined){
                            return(
                                <Grid container spacing={16} alignItems='center' direction='column' justify='center'>
                                 <Tabs
                                    // style={{width: '100%'}}
                                    activeTab={{
                                        // id: "tab1"
                                        id:this.props.caseData.namesOfVendors[0].a4
                                    }}
                                    >
                                    {
                                        
                                        this.props.caseData.namesOfVendors.map((name, index) => (
                                            <Tabs.Tab id={name.a4} title={name.a4}>
                                            <Grid alignItems='center' justify='center'>
                                                <h4 style={{display: 'block', width: '79%', textAlign: 'left', padding:'5px', margin: '0 Auto'}}>{this.context.t('Please provide your signature below')}: <b>{name.a4}</b></h4><br></br>
                                                <Card className={classes.container}>
                                                    <div className={classes.sigContainer}>
                                                        <SignatureCanvas
                                                            // style={{width: '50%'}}
                                                            clearOnResize={false}
                                                            canvasProps={{className: classes.sigPad}}
                                                            ref= { (ref) => { this.sigPad[name.a4] = ref }}
                                                        />
                                                    </div>
                                                    <CardActions>
                                                        <Button
                                                            variant="contained"
                                                            type="submit"
                                                            color="primary"
                                                            //className={classes.button}
                                                            classes={{ root: classes.button }}
                                                            onClick={this.clear.bind(this,name.a4)}
                                                            
                                                            // size='small' //assign  it small if its a mobile screen
                                                        >
                                                            {this.context.t('Reset')}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            type="submit"
                                                            color="primary"
                                                            className={classes.button}
                                                            // onClick={this.trim}
                                                            onClick={this.trim.bind(this, name.a4)}
                                                            
                                                        >
                                                            {this.context.t('Submit')}
                                                        </Button>
                                                        
                                                    </CardActions>
                                                </Card>  
                                            </Grid>
                                            </Tabs.Tab>
                                        ))
                                    }
                                    </Tabs>
                                    <Grid >
                                        <Button
                                            disabled = {this.state.signSubmitted}
                                            variant="contained"
                                            type="submit"
                                            color="primary"
                                            className={classes.button}
                                            onClick={this.props.handleComplete}
                                        >
                                            {this.context.t('Confirm Signature')}
                                        </Button>
                                    </Grid>
                                    <Grid >
                                        <PDF isDesktop={this.props.isMobile} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                                    </Grid>
                                </Grid>                      
                            );
                        }
                    }
                    else if (this.props.caseData.a2 == 'purchaser'){
                        console.log('signatureCanvasWrapper a2: purchaser')
                        if (this.props.caseData.namesOfPurchasers !== undefined){
                            return(
                                <Grid container spacing={16} alignItems='center' direction='column' justify='center'>
                                 <Tabs
                                    // style={{width: '100%'}}
                                    activeTab={{
                                        // id: "tab1"
                                        id:this.props.caseData.namesOfPurchasers[0].a12a
                                    }}
                                    >
                                    {
                                        
                                        this.props.caseData.namesOfPurchasers.map((name, index) => (
                                            <Tabs.Tab id={name.a12a} title={name.a12a}>
                                            <Grid alignItems='center' justify='center'>
                                                <h4 style={{display: 'block', width: '79%', textAlign: 'center', padding:'5px', margin: '0 Auto'}}>{this.context.t('Please provide your signature below')}: <b>{name.a12a}</b></h4><br></br>
                                                <Card className={classes.container}>
                                                    <div className={classes.sigContainer}>
                                                        <SignatureCanvas
                                                            // style={{width: '50%'}}
                                                            clearOnResize={false}
                                                            canvasProps={{className: classes.sigPad}}
                                                            ref= { (ref) => { this.sigPad[name.a12a] = ref }}
                                                        />
                                                    </div>
                                                    <CardActions>
                                                        <Button
                                                            variant="contained"
                                                            type="submit"
                                                            color="primary"
                                                            //className={classes.button}
                                                            classes={{ root: classes.button }}
                                                            onClick={this.clear.bind(this,name.a12a)}
                                                            // size='small' //assign  it small if its a mobile screen
                                                        >
                                                            {this.context.t('Reset')}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            type="submit"
                                                            color="primary"
                                                            className={classes.button}
                                                            // onClick={this.trim}
                                                            onClick={this.trim.bind(this, name.a12a)}
                                                            
                                                        >
                                                            {this.context.t('Submit')}
                                                        </Button>
                                                        
                                                    </CardActions>
                                                </Card>  
                                            </Grid>
                                            </Tabs.Tab>
                                        ))
                                    }
                                    </Tabs>
                                    <Grid >
                                        <Button
                                            disabled = {this.state.signSubmitted}
                                            variant="contained"
                                            type="submit"
                                            color="primary"
                                            className={classes.button}
                                            onClick={this.props.handleComplete}
                                        >
                                            {this.context.t('Confirm Signature')}
                                        </Button>
                                    </Grid>
                                    <Grid >
                                        <PDF isDesktop={this.props.isMobile} fileURLNoName={this.state.fileURL} file={this.props.fileURL}/>
                                    </Grid>
                                </Grid>                      
                            );
                    }

                }
            }
                else if (this.props.caseData.a1 == 'seperate'){
                    console.log('signatureCanvasWrapper a1: seperate')
                    if (this.props.caseData.namesOfA2 !== undefined){
                        return(
                            <Grid container spacing={16} alignItems='center' direction='column' justify='center'>
                                 <Tabs
                                    // style={{width: '100%'}}
                                    activeTab={{
                                        // id: "tab1"
                                        id:this.props.caseData.namesOfA2[0].a4
                                    }}
                                    >
                                    {
                                        
                                        this.props.caseData.namesOfA2.map((name, index) => (
                                            <Tabs.Tab id={name.a4} title={name.a4}>
                                            <Grid alignItems='center' justify='center'>
                                                <h4 style={{display: 'block', width: '79%', textAlign: 'center', padding:'5px', margin: '0 Auto'}}>{this.context.t('Please provide your signature below')}: <b>{name.a4}</b></h4><br></br>
                                                <Card className={classes.container}>
                                                    <div className={classes.sigContainer}>
                                                        <SignatureCanvas
                                                            // style={{width: '50%'}}
                                                            clearOnResize={false}
                                                            canvasProps={{className: classes.sigPad}}
                                                            ref= { (ref) => { this.sigPad[name.a4] = ref }}
                                                        />
                                                    </div>
                                                    <CardActions>
                                                        <Button
                                                            variant="contained"
                                                            type="submit"
                                                            color="primary"
                                                            //className={classes.button}
                                                            classes={{ root: classes.button }}
                                                            onClick={this.clear.bind(this,name.a4)}
                                                            // size='small' //assign  it small if its a mobile screen
                                                        >
                                                            {this.context.t('Reset')}
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            type="submit"
                                                            color="primary"
                                                            className={classes.button}
                                                            // onClick={this.trim}
                                                            onClick={this.trim.bind(this, name.a4)}
                                                            
                                                        >
                                                            {this.context.t('Submit')}
                                                        </Button>
                                                        
                                                    </CardActions>
                                                </Card>  
                                            </Grid>
                                            </Tabs.Tab>
                                        ))
                                    }
                                    </Tabs>
                                    <Grid >
                                        <Button
                                            disabled = {this.state.signSubmitted}
                                            variant="contained"
                                            type="submit"
                                            color="primary"
                                            className={classes.button}
                                            onClick={this.props.handleComplete}
                                        >
                                            {this.context.t('Confirm Signature')}
                                        </Button>
                                    </Grid>
                                    <Grid >
                                        <PDF isDesktop={this.props.isMobile} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                                    </Grid>
                                </Grid>                       
                        );
                    }
                }
                
            }
            else if (this.props.caseData.agreement_type == 'MoneyLent'){
                console.log('signatureCanvasWrapper agreement_type: MoneyLent')
                return(
                    <Grid container spacing={16} alignItems='center' direction='row' justify='center'>
    
                        <Grid item md={6} lg={6} sm={6} xs={12} alignItems='center' justify='center'>
                            <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto'}}>{this.context.t('Please provide your signature below')}</h4><br></br>
                            <Card className={classes.container}>
                                <div className={classes.sigContainer}>
                                    <SignatureCanvas
                                        clearOnResize={false}
                                        canvasProps={{className: classes.sigPad}}
                                        ref= {(ref) => { this.sigPad['a'] = ref }}
                                    />
                                </div>
                                <CardActions>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        //className={classes.button}
                                        classes={{ root: classes.button }}
                                        onClick={this.clear.bind(this,'a')}
                                        // size='small' //assign  it small if its a mobile screen
                                    >
                                        {this.context.t('Reset')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.button}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a')}
                                    >
                                        {this.context.t('Submit')}
                                    </Button>
                                    {/* <Button
                                        disabled = {this.state.signSubmitted}
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.button}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('Confirm Signature')}
                                    </Button> */}
                                </CardActions>
                            </Card>  
                        </Grid>
                        <Grid >
                                    <Button
                                        disabled = {this.state.signSubmitted}
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={classes.button}
                                        onClick={this.props.handleComplete}
                                    >
                                        {this.context.t('Confirm Signature')}
                                    </Button>
                          
                            <PDF isDesktop={this.props.isMobile} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                        </Grid>
                    </Grid>                      
                );
            }
        }

        if (userType == 'claimant'){
            console.log('signatureCanvasWrapper userType: claimant*')
            return(
                <Grid spacing={16} alignItems='center' direction='row' justify='center'>

                    <Grid item md={6} lg={6} sm={6} xs={12} alignItems='center' justify='center'>
                        <h4 style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto'}}>{this.context.t('Please provide your signature below')}</h4><br></br>
                        <Card className={classes.container}>
                            <div className={classes.sigContainer}>
                                <SignatureCanvas
                                    clearOnResize={false}
                                    canvasProps={{className: classes.sigPad}}
                                    ref= {(ref) => { this.sigPad['a'] = ref }}
                                />
                            </div>
                            <CardActions>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    //className={classes.button}
                                    classes={{ root: classes.button }}
                                    onClick={this.clear.bind(this,'a')}
                                    // size='small' //assign  it small if its a mobile screen
                                >
                                    {this.context.t('Reset')}
                                </Button>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.button}
                                    // onClick={this.trim}
                                    onClick={this.trim.bind(this, 'a')}
                                >
                                    {this.context.t('Submit')}
                                </Button>
                                <Button
                                    disabled = {this.state.signSubmitted}
                                    variant="contained"
                                    type="submit"
                                    color="primary"
                                    className={classes.button}
                                    onClick={this.props.handleComplete}
                                >
                                    {this.context.t('Confirm Signature')}
                                </Button>
                            </CardActions>
                        </Card>  
                    </Grid>
                    <Grid item md={6} lg={6} sm={6} xs={12} alignItems='center' justify='center'>
                        <PDF isDesktop={this.props.isMobile} fileURLNoName={this.state.fileURL} file={this.state.fileURL}/>
                    </Grid>
                </Grid>                      
            );
        }
        
        if (localStorage.getItem('typeOfAccount') == 'arbitrator' || localStorage.getItem('typeOfAccount') == 'admin'){
            console.log('SignatureCanvasWrapperArbitrator entered!!!@')
            // let fileURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getPdf/?id=${this.props.conversationId}_award`;
            // let fileDocURL = `${process.env.REACT_APP_SERVER_HOSTNAME}:9000/getDoc/?id=${this.props.conversationId}_award`;
            return(
                <Grid id="abc" spacing={16} alignItems='center' direction='row' justify='center'>
                    <Grid item md={12} lg={12} sm={12} xs={12} alignItems='center' justify='center'>
                        <Grid item md={12} lg={12} sm={12} xs={12} alignItems='center' justify='center'>
                            <PDF fileURLNoName={this.state.fileURL} isDesktop={this.props.isMobile} isAdmin={true} isAward={true} wordFile={this.state.fileDocURLAward} file={this.state.fileURLAward}/>
                        </Grid>
                        <UploadDocsSingleFile  doc_type={"award"} />
                        <h4  style={{display: 'block', width: '79%', textAlign: 'center', margin: '0 Auto', marginBottom:'10px', marginTop:'10px'}}>{this.context.t('Please provide your signature belowAward')}</h4><br></br>
                        <Card className={ lang == 'en' ? classes.container  : classes.containerChi }>
                            <div className={classes.sigContainer}>
                                <SignatureCanvas
                                    clearOnResize={false}
                                    canvasProps={{className: classes.sigPad}}
                                    ref= {(ref) => { this.sigPad['a'] = ref }}
                                />
                            </div>
                            <CardActions style={{ textAlign:'center' }}>
                                <div style={{ textAlign:'center', width:'100%' }}>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        //className={classes.button}
                                        classes={{ root: lang == 'en'? classes.button : classes.buttonChi }}
                                        onClick={this.clear.bind(this,'a')}
                                        // size='small' //assign  it small if its a mobile screen
                                    >
                                        {this.context.t('Reset')}
                                    </Button>
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        disabled = {this.state.signLoadingNoSave}
                                        className={ lang == 'en'? classes.button : classes.buttonChi}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a', false)}
                                    >
                                        {this.state.signLoadingNoSave ? this.context.t('uploading') : this.context.t('Submit')}
                                    </Button>

{/* 
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        disabled = {this.state.signLoading}
                                        className={ lang == 'en'? classes.button : classes.buttonChi}
                                        // onClick={this.trim}
                                        onClick={this.trim.bind(this, 'a', true)}
                                    >
                                        {this.state.signLoading ? this.context.t('uploading') : this.context.t('SubmitAndSetAsDefault')}
                                    </Button> */}


                                    {/* <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        disabled = {this.state.signLoading}
                                        className={classes.button}
                                        onClick={this.trim.bind(this, 'a')}
                                    >
                                        {this.state.signLoading ? this.context.t('uploading') : this.context.t('Submit')}
                                    </Button> */}
                              
                                    {/* {this.state.hasDefaultSignature && <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        disabled = {this.state.signLoadingAsDefault}
                                        className={ lang == 'en'? classes.button : classes.buttonChi}
                                        // onClick={this.trim}
                                        onClick={this.useDefault.bind(this, 'a')}
                                    >
                                        {this.state.signLoadingAsDefault ? this.context.t('uploading') : this.context.t('useDefaultSignature')}
                                    </Button>} */}
                                    <Button
                                        variant="contained"
                                        type="submit"
                                        color="primary"
                                        className={ lang == 'en'? classes.button : classes.buttonChi}
                                        onClick={this.deliveraward.bind(this)}
                                    >
                                        {this.context.t('Deliver Award')}
                                    </Button>
                                </div>
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        conversationId: state.caseInfo.conversationId,
        caseId: state.caseInfo.caseId,
        claimantUniqueId: state.caseInfo.claimantUniqueId,
        respondentUniqueId: state.caseInfo.respondentUniqueId,
        claimant_name: state.caseInfo.claimant_name,
        respondent_name: state.caseInfo.respondent_name,
        userType: state.caseInfo.userType,
        caseData: state.caseInfo.caseData,
    }
  }
  
  const mapDispatchToProps = (dispatch) => {
    return {
        uploadSignature: (caseId, file_name, userType, name, base_data, useDefault, setDefault) => dispatch(actions.uploadSignature(caseId, file_name, userType, name, base_data, useDefault, setDefault)),
        deliverAward: (caseId) => dispatch(actions.deliverAward(caseId)),
    }
  }

  const mapSizesToProps = sizes => ({
    isMobile: withSizes.isMobile(sizes),
    isTablet : withSizes.isTablet(sizes),
    isDesktop : withSizes.isDesktop(sizes),
    isGtMobile : withSizes.isGtMobile(sizes),
    isGtTablet : withSizes.isGtTablet(sizes),
    isStTablet : withSizes.isStTablet(sizes),
    isStDesktop : withSizes.isStDesktop(sizes),
    isTabletAndGreater : withSizes.isTabletAndGreater(sizes),
    isTabletAndSmaller : withSizes.isTabletAndSmaller(sizes),

})

  SignatureCanvasWrapperArbitrator.contextTypes = {
    t: PropTypes.func
  }

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withSizes(mapSizesToProps) (withRouter(SignatureCanvasWrapperArbitrator))) );